/**
 * Протокол клиентских событий аналитики (docs/specs/client-events.md §4.2).
 * Общий файл: клиент формирует пачку, сервер её разбирает.
 */
export namespace ClientEvents {
    export const BATCH_PATH = '/api/ui/batch'
    export const MAX_EVENTS_PER_BATCH = 20

    export interface Batch {
        v: 1                       // версия протокола
        vid: string                // visitor_id, UUID v4
        s?: string                 // сессия чата, если есть
        events: Event[]
    }

    export interface Event {
        e: string                  // имя события из реестра
        ts: number                 // время на клиенте, мс
        page?: string              // путь страницы без query и hash, например '/chat'
        p?: Record<string, string | number | boolean>   // поля события
    }
}
